import { getValueByPath } from '../../../../../../../../helpers/getValueByPath';
import { createOptionNode } from './composite';
import {
  entriesFactoryKeys,
  optionSchemas,
  optionsFactoryKeys,
} from './config';
import { createEntries } from './entriesFactory';
import { sortingStrategies } from './sortingStrategies';
import { createOptionTreeManager } from './treeManager';

const initKeysToResultKeys = {
  emptyCellRoomOptions: 'rooms',
  porchOptions: 'porchs',
  floorOptionTreeManager: 'floors',
  roomOptionTreeManager: 'gridRooms',
};

export const createResult = (data) =>
  Object.entries(data).reduce((acc, { 0: initKey, 1: value }) => {
    const key = initKeysToResultKeys[initKey];
    acc[key] = value.normalize().children;
    return acc;
  }, {});

export const getInitialData = () => ({
  emptyCellRoomOptions: createOptionNode({ type: optionsFactoryKeys.leaf }),
  porchOptions: createOptionNode({ type: optionsFactoryKeys.leaf }),
  floorOptionTreeManager: createOptionTreeManager({
    schema: optionSchemas.floor,
    sortStrategy: sortingStrategies.bySortOrder,
  }),
  roomOptionTreeManager: createOptionTreeManager({
    schema: optionSchemas.room,
    sortStrategy: sortingStrategies.bySortOrder,
  }),
});

export const createRoomsIteratorCb = (initialData) => {
  const { emptyCellRoomOptions, ...otherData } = initialData;

  return (room) => {
    const { cells } = room;

    if (!cells?.length) {
      emptyCellRoomOptions.add({ value: room });
      return;
    }

    const cellsIteratorCb = createCellsIteratorCb(otherData, room);
    cells.forEach(cellsIteratorCb);
  };
};

export const getLeafNodesValues = ({ nodes, pathToValue = 'id' }) => {
  const stack = [...nodes];
  const values = new Set();

  while (stack.length > 0) {
    const node = stack.pop();

    node.children
      ? stack.push(...node.children)
      : values.add(getValueByPath(node, pathToValue));
  }

  return [...values];
};

function createCellsIteratorCb(initialData, room) {
  const { porchOptions, floorOptionTreeManager, roomOptionTreeManager } =
    initialData;

  return (cell) => {
    const { porch, row } = cell;
    const normPorch = porch.trim();
    const normFloor = row.trim();

    porchOptions.add({ value: normPorch });

    const floorEntries = createEntries(entriesFactoryKeys.floor, {
      porch: normPorch,
    });
    floorOptionTreeManager.add(floorEntries, normFloor);

    const roomEntries = createEntries(entriesFactoryKeys.room, {
      porch: normPorch,
      floor: normFloor,
    });
    roomOptionTreeManager.add(roomEntries, room);
  };
}
